var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sl-screen',{attrs:{"pagetype":"0","pagename":"","title":_vm.$t('sl.itandxpdigitale.title'),"titlecolor":""}})}
var staticRenderFns = []

export { render, staticRenderFns }